interface FilterSidebarProps {
  typeFilter: string;
  onTypeChange: (value: string) => void;
  yearFilter: string;
  onYearChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  onReset: () => void;
  years: number[];
  resultCount: number;
}

const typeOptions = ["全部", "电影", "电视剧"];
const sortOptions = ["最新", "热门"];

function OptionButton({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
        active
          ? "bg-primary-500 text-background-50 font-medium"
          : "bg-background-100 text-foreground-600 hover:bg-background-200"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterSidebar({
  typeFilter,
  onTypeChange,
  yearFilter,
  onYearChange,
  sort,
  onSortChange,
  onReset,
  years,
  resultCount,
}: FilterSidebarProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <span className="text-sm text-foreground-500">
          共 <strong className="text-primary-600">{resultCount}</strong> 部作品
        </span>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <div>
        <h3 className="text-sm font-semibold text-foreground-950 mb-3">作品类型</h3>
        <div className="flex flex-wrap gap-2">
          {typeOptions.map((option) => (
            <OptionButton
              key={option}
              label={option}
              active={typeFilter === option}
              onClick={() => onTypeChange(option)}
            />
          ))}
        </div>
      </div>

      <div className="h-px bg-background-200"></div>

      <div>
        <h3 className="text-sm font-semibold text-foreground-950 mb-3">上映年代</h3>
        <div className="flex flex-wrap gap-2">
          <OptionButton
            label="全部"
            active={yearFilter === "全部"}
            onClick={() => onYearChange("全部")}
          />
          {years.map((year) => (
            <OptionButton
              key={year}
              label={`${year}`}
              active={yearFilter === `${year}`}
              onClick={() => onYearChange(`${year}`)}
            />
          ))}
        </div>
      </div>

      <div className="h-px bg-background-200"></div>

      <div>
        <h3 className="text-sm font-semibold text-foreground-950 mb-3">排序方式</h3>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((option) => (
            <OptionButton
              key={option}
              label={option}
              active={sort === option}
              onClick={() => onSortChange(option)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}